// src/components/PlanlanmisOdemeModal.js

import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, FormControl, InputLabel, Select, MenuItem, Alert, CircularProgress } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { db } from '../firebase';
// GÜNCELLENDİ: doc ve updateDoc eklendi
import { collection, addDoc, serverTimestamp, Timestamp, doc, updateDoc } from 'firebase/firestore';

// GÜNCELLENDİ: 'paymentToEdit' prop'u eklendi
const PlanlanmisOdemeModal = ({ isOpen, onClose, customer, finalBalance, paymentToEdit }) => {
  const [tutar, setTutar] = useState('');
  const [vadeTarihi, setVadeTarihi] = useState(null);
  const [odemeYontemi, setOdemeYontemi] = useState('Nakit');
  const [aciklama, setAciklama] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  
  const isEditing = Boolean(paymentToEdit); // Düzenleme modunda olup olmadığını kontrol et

  useEffect(() => {
    if (isOpen) {
        if (isEditing && paymentToEdit) {
            // Düzenleme modu: Formu doldur
            setTutar(paymentToEdit.tutar.toString());
            setVadeTarihi(paymentToEdit.vadeTarihi.toDate());
            setOdemeYontemi(paymentToEdit.odemeYontemi || 'Nakit');
            setAciklama(paymentToEdit.aciklama || '');
        } else {
            // Yeni ekleme modu: Formu sıfırla
            setTutar('');
            setVadeTarihi(null);
            setOdemeYontemi('Nakit');
            setAciklama('');
        }
    }
  }, [isOpen, isEditing, paymentToEdit]);

  const handleSubmit = async () => {
    if (!tutar || !vadeTarihi) {
      alert('Tutar ve Vade Tarihi alanları zorunludur.');
      return;
    }
    // GÜNCELLENDİ: Borç kontrolü sadece YENİ eklerken yapılır
    if (!isEditing && finalBalance <= 0) {
        alert('Müşterinin mevcut borcu bulunmamaktadır. Borcu olmayan bir müşteri için vadeli tahsilat planlanamaz.');
        return;
    }
    setIsSaving(true);
    
    const dataToSave = {
        musteriId: customer.id,
        musteriAdSoyad: customer.adSoyad,
        tutar: Number(tutar),
        vadeTarihi: Timestamp.fromDate(vadeTarihi),
        odemeYontemi,
        aciklama: (aciklama || '').toLocaleUpperCase('tr-TR'), // Faz 4.5: BÜYÜK HARF
        durum: 'Bekleniyor', // Düzenlense bile durumu 'Bekleniyor' kalsın
    };

    try {
      if (isEditing) {
        // GÜNCELLENDİ: Düzenleme modu (Update)
        const docRef = doc(db, "scheduledPayments", paymentToEdit.id);
        await updateDoc(docRef, dataToSave);
        alert('Planlanmış tahsilat başarıyla güncellendi!');
      } else {
        // Yeni ekleme modu (Add)
        await addDoc(collection(db, "scheduledPayments"), {
          ...dataToSave,
          eklenmeTarihi: serverTimestamp(),
        });
        alert('Planlanmış tahsilat başarıyla eklendi!');
      }
      setIsSaving(false);
      onClose();
    } catch (error) {
      console.error("Planlanmış ödeme kaydedilirken/güncellenirken hata: ", error);
      alert('Bir hata oluştu.');
      setIsSaving(false);
    }
  };
  
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{isEditing ? 'Planlanmış Tahsilatı Düzenle' : 'Vadeli / Planlanmış Tahsilat Ekle'}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* GÜNCELLENDİ: Uyarı sadece yeni ekleme modunda ve bakiye yoksa gösterilir */}
            {!isEditing && finalBalance <= 0 && (
                <Alert severity="warning">Bu müşterinin borcu bulunmamaktadır.</Alert>
            )}
            <DatePicker label="Vade Tarihi *" value={vadeTarihi} onChange={setVadeTarihi} />
            <TextField label="Tutar (₺)" type="number" value={tutar} onChange={(e) => setTutar(e.target.value)} required />
            <FormControl fullWidth><InputLabel>Ödeme Yöntemi</InputLabel><Select value={odemeYontemi} label="Ödeme Yöntemi" onChange={(e) => setOdemeYontemi(e.target.value)}><MenuItem value="Nakit">Nakit</MenuItem><MenuItem value="Kredi Kartı">Kredi Kartı</MenuItem><MenuItem value="Havale/EFT">Havale/EFT</MenuItem></Select></FormControl>
            <TextField label="Açıklama" value={aciklama} onChange={(e) => setAciklama(e.target.value)} multiline rows={2} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={onClose} disabled={isSaving}>İptal</Button>
        <Button 
            onClick={handleSubmit} 
            variant="contained" 
            // GÜNCELLENDİ: Kaydetme butonu, düzenleme modundaysa her zaman etkindir
            disabled={isSaving || (!isEditing && finalBalance <= 0)}
        >
          {isSaving ? <CircularProgress size={24} /> : (isEditing ? 'Güncelle' : 'Kaydet')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default PlanlanmisOdemeModal;